module.exports = __webpack_public_path__ + "static/media/delete.af7e11a0.svg";